import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  NgZone,
  OnInit,
  Output,
  ViewChild,
  TemplateRef,
} from "@angular/core";
import resourceTimelinePlugin from "@fullcalendar/resource-timeline";
import bootstrapPlugin from "@fullcalendar/bootstrap";
import interactionPlugin from "@fullcalendar/interaction";

import { ParksHandlerService } from "../../../api-handlers/parks-handler.service";
import { User } from "../../../models/user";
import { AuthService } from "../../../auth-n-routing/auth-service.service";
import { Park } from "../../../models/park";
import { VehiclesHandlerService } from "../../../api-handlers/vehicles-handler.service";
import { Vehicle } from "../../../models/vehicle";
import { AssignUserToCarComponent } from "../../../dialogs/assign-user-to-car/assign-user-to-car.component";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { TravelsHandlerService } from "../../../api-handlers/travels-handler.service";
import { TechnicalShutdown } from "../../../models/technical_shutdown";

@Component({
  selector: "app-admin-available-vehicles",
  templateUrl: "./admin-available-vehicles.component.html",
  styleUrls: ["./admin-available-vehicles.component.scss"],
})
export class AdminAvailableVehiclesComponent implements OnInit {
  @ViewChild(AssignUserToCarComponent, { static: false })
  assignUserToCarDialog: AssignUserToCarComponent;
  @ViewChild("templateViaggio", { static: false })
  public templateref: TemplateRef<any>;

  @Output() statusChanged = new EventEmitter(); // implementare emit per aggiornare le altre tab

  parks = [];
  options = {};

  eventCLicked: any;
  bsModalRef: BsModalRef;

  constructor(
    private parksHandler: ParksHandlerService,
    private travelHandler: TravelsHandlerService,
    private authService: AuthService,
    private vehicleHandler: VehiclesHandlerService,
    private ngZone: NgZone,
    private modalService: BsModalService,
    private changeDetector: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.authService.authChange.subscribe((u: User) => {
      if (u) {
        this.reloadParks();
      }
    });
  }

  isOptionsEmpty = () => JSON.stringify(this.options) === "{}";

  reloadParks() {
    this.parksHandler.getByAdminID().then((res) => {
      this.parks = [];
      res.forEach((park, _index) => {
        park["isOpen"] = true;
        this.parks.push(park);

        this.options[park.id] = {
          plugins: [bootstrapPlugin, interactionPlugin, resourceTimelinePlugin],
          initialView: "resourceTimelineMonth",
          themeSystem: "bootstrap",
          views: {
            resourceTimelineMyMonthView: {
              type: "resourceTimelineMonth",
            },
            resourceTimelineWeekView: {
              type: "resourceTimelineWeek",
            },
            resourceTimelineDayView: {
              type: "resourceTimelineDay",
            },
          },
          headerToolbar: {
            left: "prev,next",
            center: "today",
            right:
              "resourceTimelineMyMonthView,resourceTimelineWeekView,resourceTimelineDayView",
          },
          schedulerLicenseKey: "GPL-My-Project-Is-Open-Source",
          locale: "it",
          resources: [],
          events: [],
          eventClick: this.myEventClick.bind(this),
          weekends: true,
        };
      });

      // this.parks.forEach((park) => {
      //   this.openChanged(park);
      // });

      this.changeDetector.detectChanges();
    });
  }

  openChanged(park: Park) {
    /*if (!this.vehicles[park.id] || this.vehicles[park.id].length === 0) {*/
    if (park["isOpen"]) {
      this.getVehiclesFromPark(park);
    }
  }

  /*updateCharts(park: Park) {


		//Permette di puntare direttamente a TODAY fullcalendar
		this.ngZone.run(() => {
			setTimeout(() => {

				const element: HTMLElement = document.getElementsByClassName('fc-resourceTimelineMonth-button')[0] as HTMLElement;
				element.click();

				const d = new Date();
				const d2 = new Date(d.getFullYear(), d.getMonth(), 1);
				console.log(d);
				console.log(d2);
				const timeDiff = Math.abs(d2.getTime() - d.getTime());
				const td = Math.ceil(timeDiff / (1000 * 3600 * 24));
				console.log(td);

				calendarApi.scrollToTime(timeDiff);

			}, 4000);


		});
	}*/

  getEventColor(status, ended): string {
    if (status === 2) {
      return "red";
    } else if (status === 3 && ended == null) {
      return "blue";
    } else if (status === 3 && ended != null) {
      return "green";
    }
  }

  getVehiclesFromPark(park: Park) {
    this.vehicleHandler.getByParkID(park.id).then((res2) => {
      this.vehicleHandler
        .getTechnicalShutdownByPark(park, false)
        .then((tsList: TechnicalShutdown[]) => {
          this.travelHandler.getTravelForAdminCalendar(park.id).then((res) => {
            this.ngZone.run(() => {
              this.options[park.id]["resources"] = [];
              this.options[park.id]["events"] = [];
              res2.forEach((v: Vehicle) => {
                this.options[park.id]["resources"].push({
                  id: v.id,
                  title:
                    v.plate +
                    " (#" +
                    v.id +
                    ") " +
                    v.model.name +
                    " - " +
                    v.model.brand.name,
                  eventColor: "gray",
                });
              });

              res["travel"].forEach((t) => {
                this.options[park.id]["events"].push({
                  id: "tr_" + t.trv_id,
                  travel_id: t.trv_id,
                  resourceId: t.vhc_id,
                  start: t.trv_required_from,
                  end: t.trv_required_to,
                  title: t.trv_id,
                  userName: t.usr_name,
                  userSurname: t.usr_surname,
                  motivation: t.trv_motivation,
                  motivation_name: t.trv_motivation_name,
                  motivation_other: t.trv_motivation_other,
                  passengers: t.trv_passengers,
                  backgroundColor: this.getEventColor(
                    t.trv_status_id,
                    t.trv_ended_at
                  ),
                  type: "travel",
                });
              });

              tsList.forEach((ts: TechnicalShutdown) => {
                this.ngZone.run(() => {
                  this.options[park.id]["events"].push({
                    id: "ts_" + ts.id,
                    tech_shut_id: ts.id,
                    resourceId: ts.vehicle_id,
                    start: ts._from,
                    end: ts.to ? ts.to : new Date("01/01/2100"), // nel 2100 toccherà fixà
                    motivation: ts.motivation,
                    type: "technical_shutdown",
                    backgroundColor: "purple",
                  });
                });
              });

              this.changeDetector.detectChanges();
            });
          });
        });
    });
  }

  myEventClick(arg) {
    this.eventCLicked = arg;
    this.openModal(this.templateref);
    console.log(this.eventCLicked)
  }

  determineMotivationOther(travel): string {
    return travel.motivation === 3 ? travel.motivation_other : travel.motivation_name;
  }

  // MEtodo per personalizzare la visualizzazione degli eventi sul FULLCALENDAR
  eventRender(model: any): void {
    // model.el.className += ''
    // model.el.innerHTML += '<strong>Viaggio</strong>';
  }

  openModal(template: TemplateRef<any>) {
    this.bsModalRef = this.modalService.show(template);
  }

  openAssignVehicleDialog(e) {
    e.el.onclick = () => {
      console.log(e.resource.id);
      /*this.vehicleHandler.getVehicleById(e.resource.id).then((vehicle: Vehicle) => {
				console.log(vehicle);
				//this.assignUserToCarDialog.showDialog(vehicle);
			});*/
    };
  }

  vehicleAssigned() {
    this.reloadParks();
    this.statusChanged.next(undefined);
  }
}
